import { Show, SimpleShowLayout, TextField } from "react-admin";
import { ShowHeader } from "../../utils/header";

export function GenreShow(): JSX.Element {
    return (
        <Show title={<ShowHeader field="name" />}>
            <SimpleShowLayout>
                <TextField source="id" />
                <TextField source="name" />
                <TextField source="description" />
            </SimpleShowLayout>
        </Show>
    );
}
